import type { FunctionComponent } from "react";

import { usePostiesFormDrawerContext } from "scmp-app/components/posties/form-drawer/contexts";

import { BackDrop, CloseButton, Container, Message, StyledBackButton, Wrapper } from "./styles";
import WarningSvg from "./warning.svg";

type Props = {
  onClose: () => void;
};

export const PostiesAlertBox: FunctionComponent<Props> = ({ onClose }) => {
  const { setShowAlertBox, showAlertBox } = usePostiesFormDrawerContext();

  if (!showAlertBox) return null;

  return (
    <>
      <Container>
        <Wrapper>
          <WarningSvg />
          <Message>
            Are you sure you want to close this form? If you leave without submitting, your work
            will be lost.
          </Message>
          <StyledBackButton
            onClick={() => {
              setShowAlertBox?.(false);
            }}
            variant="button"
          >
            BACK TO FORM
          </StyledBackButton>
          <CloseButton
            onClick={() => {
              onClose();
              setShowAlertBox?.(false);
            }}
          >
            Yes, close it anyway.
          </CloseButton>
        </Wrapper>
      </Container>
      <BackDrop />
    </>
  );
};

PostiesAlertBox.displayName = "PostiesAlertBox";
